export class GuestUser {

    constructor(
      public company_name?: string,
      public cin_no?: string,
      public gst_no?: string,
      public password?: string,
      public confirm_password?: string,
      public contact_person_name?: string,
      public email?:string,
      public alt_email?:string,
      public state_id?:number,
      public city_id?:number,
      public country_id?:number,
      public address?:string,
      public logo?:string,
      public user_name?:string,
      public contact_no?:number,
      public alt_contact_no?:number,
      public pin_code?:number,
      public empType?: string

    ) {
      this.company_name = company_name;
      this.cin_no = cin_no;
      this.gst_no = gst_no;
      this.contact_person_name = contact_person_name;
      this.email = email;
      this.alt_email = alt_email;
      this.state_id = state_id;
      this.city_id = city_id;
      this.country_id = country_id
      this.address = address;
      this.password = password;
      this.logo = logo;
      this.user_name = user_name;
      this.contact_no = contact_no;
      this.alt_contact_no = alt_contact_no;
      this.confirm_password = confirm_password;
      this.pin_code = pin_code;
      this.empType = empType
    }
  }